import { search } from "../types";

export const setSearchQuery = (query) => async (dispatch) => {
  dispatch({ type: search.SET_SEARCH_QUERY, payload: { query } });
};
